import React, {useState} from 'react';
import '../../../css/web/UserHome.css';
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {SiFacebook, SiInstagram, SiTiktok, SiYoutube} from "react-icons/si";

import {useChat} from "../../contextApi/ChatContext";
import {usePopup} from "../../contextApi/FooterOpenChatContext";
import useTheme from "../layoutscommon/DarkModeStorage";
import CommonTermsPopup from "../modal/CommonTermsPopup";

import btorageBooster from '../../../assets/img/btorageBooster.png';
import footerCenterLogo from '../../../assets/img/footerCenterLogo.png';
import Kpacket from '../../../assets/img/Kpacket.png';
import emsGrey from "../../../assets/img/emsgrey.png";
import fedexGrey from "../../../assets/img/fedexgrey.png";
import upsGrey from "../../../assets/img/upsgrey.png";
import paypalGrey from "../../../assets/img/paypal-footer.png";

/*
 * UserFooterRenew
 * - 홈화면 리뉴얼 푸터를 공용 컴포넌트로 분리. UserHome 및 UserMainPg(하위 전 페이지)에서 공용 사용.
 * - 이용약관/개인정보 팝업 상태를 자체 관리(기존 UserFooterMain + 부모 상태 플럼빙 제거).
 * - 라이트/다크: 자체 useTheme 로 data-theme 를 부여(uh- 변수 기반).
 */
function UserFooterRenew() {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {totalUnreadCount} = useChat();
    const {setIsPopupOpen} = usePopup();
    const [theme] = useTheme();

    const [termsOfUsePopup, setTermsOfUsePopup] = useState(false);
    const [privacyPolicyPopup, setPrivacyPolicyPopup] = useState(false);

    return (
        <>
            <footer className="uh-footer" data-theme={theme}>
                <div className="uh-footer-inner">
                    <div>
                        <img className="uh-footer-logo" src={btorageBooster} alt="Btorage"/>
                        <h4>{t("fmCompNm")}</h4>
                        <p>경기도 광주시 곤지암읍 연곡길42번길 32-15</p>
                        <div className="uh-footer-partners">
                            <img src={fedexGrey} alt="fedex"/>
                            <img src={upsGrey} alt="ups"/>
                            <img src={emsGrey} alt="ems"/>
                            <img src={Kpacket} alt="kpacket"/>
                            <img src={paypalGrey} alt="paypal"/>
                        </div>
                    </div>

                    <div className="uh-footer-cols">
                        <div className="uh-footer-menu">
                            <span onClick={() => navigate('/UserUsageGuidePg')}>{t("fmSmallMenu5")}</span>
                            <span onClick={() => setTermsOfUsePopup(true)}>{t("fmSmallMenu2")}</span>
                            <span onClick={() => setPrivacyPolicyPopup(true)}>{t("fmSmallMenu3")}</span>
                            <span onClick={() => navigate("/UserMailInquiryPg", {state: {selectedType: {value: "help@btorage.com", label: t("umi6")}}})}>{t("fmSmallMenu4")}</span>
                        </div>
                        <div>
                            <p>{t("fmCompCeo")}</p>
                            <p>{t("fmCompInfoAdmin")}</p>
                            <p>{t("fmCompNum")}</p>
                            <p>{t("fmCompSalesNum")}</p>
                            <p>help@btorage.com</p>
                            <p>© 2022 Btorage Corp. All rights reserved.</p>
                        </div>
                    </div>

                    <div>
                        <h4>{t("fmCt")}</h4>
                        <div className="uh-footer-cs-num">070-4131-4180</div>
                        <div className="uh-footer-menu">
                            <p style={{display: "flex", alignItems: "center", gap: 12}}>
                                <img src={footerCenterLogo} alt="" style={{width: 40, height: 40, opacity: 0.7}}/>
                                <span>{t("fmCs")}<br/>{t("fmLunch")}</span>
                            </p>
                        </div>
                        <div className="uh-footer-sns">
                            <SiInstagram onClick={() => window.open("https://www.instagram.com/direct/t/102686091131782", "_blank")}/>
                            <SiYoutube onClick={() => window.open("https://www.youtube.com/@Btorage", "_blank")}/>
                            <SiTiktok onClick={() => window.open("https://www.tiktok.com/@btorag_e", "_blank")}/>
                            <SiFacebook onClick={() => window.open("https://www.facebook.com/?locale=ko_KR", "_blank")}/>
                        </div>
                        <div className="uh-footer-btns">
                            <button onClick={() => setIsPopupOpen(true)}>{t("fmChatBt")} {totalUnreadCount > 0 ? `(${totalUnreadCount})` : ''}</button>
                            <button onClick={() => navigate("/UserMailInquiryPg")}>{t("fmContBt")}</button>
                        </div>
                    </div>
                </div>
                <div className="uh-footer-copy">
                    <p>© 2022 Btorage Corp. All rights reserved.</p>
                </div>
            </footer>

            {termsOfUsePopup &&
                <CommonTermsPopup termsOfUsePopup={termsOfUsePopup} closeTermsOfUsePopup={() => setTermsOfUsePopup(false)}/>}
            {privacyPolicyPopup &&
                <CommonTermsPopup privacyPolicyPopup={privacyPolicyPopup} closePrivacyPolicyPopup={() => setPrivacyPolicyPopup(false)}/>}
        </>
    );
}

export default UserFooterRenew;
